import React from 'react';
import { Link } from 'react-router-dom';

const TemplatesP22 = (props) => {
    // let displayNewCards = false;
    // if (props.user.username === 'hugh.admin' || props.user.username === 'utdemo') {
    //     displayNewCards = true;
    // }

    return (
        <div className="templates-container">
            <div className="breadcrumbs">
                / <Link to="/utp">Main Categories</Link> / Clinical Signage
            </div>
            <div className="templates-row">
                <div className="category">
                    <Link to="/template/22/1"><div className="image p22-t1"></div></Link>
                    <div className="title">
                        <div className="name">Travel Notice Vinyl Wall Cling</div>
                        <div className="button-container">
                            <Link to="/template/22/1"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/22/2"><div className="image p22-t2"></div></Link>
                    <div className="title">
                        <div className="name">CDC Cover Your Cough Vinyl Wall Cling</div>
                        <div className="button-container">
                            <Link to="/template/22/2"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
                <div className="category">
                    <Link to="/template/22/3"><div className="image p22-t3"></div></Link>
                    <div className="title">
                        <div className="name">No Recording Notice Vinyl Wall Cling</div>
                        <div className="button-container">
                            <Link to="/template/22/3"><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TemplatesP22;
